import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-storyboarding',
  	templateUrl: './toolcards-storyboarding.component.html',
  	styleUrls: ['./toolcards-storyboarding.component.scss']
})
export class ToolcardsStoryboardingComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
